import { useContext } from 'react';

import StatesContext from '../../context/states';
import MobileContext from '../../context/mobile';

import { FilterDropdown } from '../FilterDropdown';
import FilterMobile from '../FilterMobile';
import { useFilters } from './lib/useFilters';

const FilterWithVacancies = () => {
  const states = useContext(StatesContext);
  const isMobile = useContext(MobileContext);

  const {
    currentQueries,
    openFilter,
    setOpenFilter,
    inputCallback,
    apply,
    reset,
    count,
    sections,
  } = useFilters(states);

  return isMobile ? (
    <FilterMobile
      openFilter={openFilter}
      setOpenFilter={setOpenFilter}
      sections={sections}
      apply={apply}
      reset={reset}
      inputCallback={inputCallback}
      currentQueries={currentQueries}
      count={count}
    />
  ) : (
    <FilterDropdown
      sections={sections}
      apply={apply}
      reset={reset}
      inputCallback={inputCallback}
      currentQueries={currentQueries}
      count={count}
    />
  );
};

export default FilterWithVacancies;
